"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateRewardConfigRequestBodyToJSON = exports.UpdateRewardConfigRequestBodyFromJSONTyped = exports.UpdateRewardConfigRequestBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function UpdateRewardConfigRequestBodyFromJSON(json) {
    return UpdateRewardConfigRequestBodyFromJSONTyped(json, false);
}
exports.UpdateRewardConfigRequestBodyFromJSON = UpdateRewardConfigRequestBodyFromJSON;
function UpdateRewardConfigRequestBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : (0, _1.RewardTypeFromJSON)(json['type']),
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'shouldEmailUser': !(0, runtime_1.exists)(json, 'shouldEmailUser') ? undefined : json['shouldEmailUser'],
        'shouldEmailAdmin': !(0, runtime_1.exists)(json, 'shouldEmailAdmin') ? undefined : json['shouldEmailAdmin'],
        'shouldSendNotificationWeb': !(0, runtime_1.exists)(json, 'shouldSendNotificationWeb') ? undefined : json['shouldSendNotificationWeb'],
        'shouldSendNotificationDevourPlay': !(0, runtime_1.exists)(json, 'shouldSendNotificationDevourPlay') ? undefined : json['shouldSendNotificationDevourPlay'],
        'amount': !(0, runtime_1.exists)(json, 'amount') ? undefined : json['amount'],
        'amountUnit': !(0, runtime_1.exists)(json, 'amountUnit') ? undefined : (0, _1.AmountUnitFromJSON)(json['amountUnit']),
        'durationAmount': !(0, runtime_1.exists)(json, 'durationAmount') ? undefined : json['durationAmount'],
        'durationUnit': !(0, runtime_1.exists)(json, 'durationUnit') ? undefined : (0, _1.DurationUnitFromJSON)(json['durationUnit']),
        'assetId': !(0, runtime_1.exists)(json, 'assetId') ? undefined : json['assetId'],
        'nftTrackerId': !(0, runtime_1.exists)(json, 'nftTrackerId') ? undefined : json['nftTrackerId'],
        'orderDiscountId': !(0, runtime_1.exists)(json, 'orderDiscountId') ? undefined : json['orderDiscountId'],
        'promoTokenId': !(0, runtime_1.exists)(json, 'promoTokenId') ? undefined : json['promoTokenId'],
        'questConfigId': !(0, runtime_1.exists)(json, 'questConfigId') ? undefined : json['questConfigId'],
        'emailTemplate': !(0, runtime_1.exists)(json, 'emailTemplate') ? undefined : (0, _1.EmailTemplateFromJSON)(json['emailTemplate']),
        'claimFormUrl': !(0, runtime_1.exists)(json, 'claimFormUrl') ? undefined : json['claimFormUrl'],
        'maxClaimCount': !(0, runtime_1.exists)(json, 'maxClaimCount') ? undefined : json['maxClaimCount'],
        'disclaimer': !(0, runtime_1.exists)(json, 'disclaimer') ? undefined : json['disclaimer'],
    };
}
exports.UpdateRewardConfigRequestBodyFromJSONTyped = UpdateRewardConfigRequestBodyFromJSONTyped;
function UpdateRewardConfigRequestBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'type': (0, _1.RewardTypeToJSON)(value.type),
        'name': value.name,
        'description': value.description,
        'shouldEmailUser': value.shouldEmailUser,
        'shouldEmailAdmin': value.shouldEmailAdmin,
        'shouldSendNotificationWeb': value.shouldSendNotificationWeb,
        'shouldSendNotificationDevourPlay': value.shouldSendNotificationDevourPlay,
        'amount': value.amount,
        'amountUnit': (0, _1.AmountUnitToJSON)(value.amountUnit),
        'durationAmount': value.durationAmount,
        'durationUnit': (0, _1.DurationUnitToJSON)(value.durationUnit),
        'assetId': value.assetId,
        'nftTrackerId': value.nftTrackerId,
        'orderDiscountId': value.orderDiscountId,
        'promoTokenId': value.promoTokenId,
        'questConfigId': value.questConfigId,
        'emailTemplate': (0, _1.EmailTemplateToJSON)(value.emailTemplate),
        'claimFormUrl': value.claimFormUrl,
        'maxClaimCount': value.maxClaimCount,
        'disclaimer': value.disclaimer,
    };
}
exports.UpdateRewardConfigRequestBodyToJSON = UpdateRewardConfigRequestBodyToJSON;
